'use client';

import React from 'react';

const GlobalStyle = () => (
  <style jsx global>{`
    body {
      background-color: #010a29;

      @media (max-width: 768px) {
        overflow-x: hidden;
      }
    }
    html {
      @media (max-width: 768px) {
        overflow-x: hidden;
      }
    }
  `}</style>
);

export default GlobalStyle;
